import React, { useState } from 'react';
import Video from './VideoStep';
import Assessment from './Assessment';
import { APP_TUTORIAL_STEPS, HEADER_TITLES } from './constants';
import Header from './Header';
import { RMAXLogger } from '../../services/LoggerService/RMAXLogger';

const AppTutorial = ({
  videoURL,
  assessmentData,
  errorMessage,
  onClose,
  componentId,
  userProfile
}) => {
  const [currentScreen, setCurrentScreen] = useState(APP_TUTORIAL_STEPS.Video);

  const switchStep = (stepName) => () => {
    setCurrentScreen(stepName);
  };

  const onSubmitAssessment = (assessmentResult) => {
    RMAXLogger.info('Assessment Submitted', {
      userId: userProfile.userId,
      terminalCode: userProfile.terminal.code,
      componentId,
      assessmentResult
    });
  };

  return (
    <>
      <Header onClose={onClose} title={HEADER_TITLES[currentScreen]} />
      {currentScreen === APP_TUTORIAL_STEPS.Video ? (
        <Video
          videoURL={videoURL}
          onClose={onClose}
          onSubmit={switchStep(APP_TUTORIAL_STEPS.Assessment)}
          errorMessage={errorMessage}
        />
      ) : (
        <Assessment
          assessmentData={assessmentData}
          goToVideo={switchStep(APP_TUTORIAL_STEPS.Video)}
          onClose={onClose}
          onSubmit={onSubmitAssessment}
        />
      )}
    </>
  );
};

export default AppTutorial;
